/** Default file for Kitchen Display new-ticket alert (place file at public/sounds/kitchen.mp3). */
export const DEFAULT_KITCHEN_ALERT_SOUND = '/sounds/kitchen.mp3';

/** Legacy default from older builds; treat as unset so we use {@link DEFAULT_KITCHEN_ALERT_SOUND}. */
export const LEGACY_KITCHEN_ALERT_SOUND = '/sounds/uber-chime.mp3';

export function resolveKitchenAlertSoundUrl(url: string | undefined | null): string {
  const t = url?.trim();
  if (!t || t === LEGACY_KITCHEN_ALERT_SOUND) return DEFAULT_KITCHEN_ALERT_SOUND;
  return t;
}
